document.addEventListener('DOMContentLoaded', function () {
  const sliderSections = document.querySelectorAll('[data-slide-reviews]');

  sliderSections.forEach((section) => {
    const track = section.querySelector('.slider-reviews-track');
    const cards = Array.from(section.querySelectorAll('.review-card'));
    const navItems = Array.from(section.querySelectorAll('.reviews-nav-item'));
    const nextBtn = section.querySelector('.reviews-next');
    const prevBtn = section.querySelector('.reviews-prev');

    let currentIndex = 0;
    const transitionDuration = 600;
    const autoSlideDelay = 4000;
    let autoSlideTimer = null;

    if (!track || !cards.length) return; // Exit if slider elements not found

    track.style.transition = `transform ${transitionDuration}ms ease`;

    function updateSlider() {
      cards.forEach((card) => card.classList.remove('active', 'prev', 'next'));

      const prevIndex = (currentIndex - 1 + cards.length) % cards.length;
      const nextIndex = (currentIndex + 1) % cards.length;
      cards[currentIndex].classList.add('active');
      cards[prevIndex].classList.add('prev');
      cards[nextIndex].classList.add('next');

      navItems.forEach((item, i) => {
        item.classList.toggle('active', i === currentIndex);
      });

      const wrapperWidth = track.parentElement.offsetWidth;
      const activeCard = cards[currentIndex];
      const cardLeft = activeCard.offsetLeft;
      const cardWidth = activeCard.offsetWidth;
      const offset = cardLeft + cardWidth / 2 - wrapperWidth / 2;

      track.style.transform = `translateX(${-offset}px)`;
    }

    function gotoSlide(index) {
      if (index < 0) index = cards.length - 1;
      if (index >= cards.length) index = 0;
      currentIndex = index;
      updateSlider();
    }

    function startAutoSlide() {
      stopAutoSlide();
      autoSlideTimer = setInterval(() => {
        gotoSlide(currentIndex + 1);
      }, autoSlideDelay);
    }

    function stopAutoSlide() {
      if (autoSlideTimer) clearInterval(autoSlideTimer);
    }

    navItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        gotoSlide(index);
        startAutoSlide();
      });
    });

    if (nextBtn)
      nextBtn.addEventListener('click', () => {
        gotoSlide(currentIndex + 1);
        startAutoSlide();
      });

    if (prevBtn)
      prevBtn.addEventListener('click', () => {
        gotoSlide(currentIndex - 1);
        startAutoSlide();
      });

    let startX = 0;
    let isDragging = false;

    function pointerDown(e) {
      isDragging = true;
      startX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      stopAutoSlide();
    }

    function pointerMove(e) {
      if (!isDragging) return;
      const x = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
      const delta = x - startX;
      track.style.transform = `translateX(calc(${track.style.transform} + ${delta}px))`;
    }

    function pointerUp(e) {
      if (!isDragging) return;
      isDragging = false;

      const endX = e.type.includes('mouse') ? e.pageX : e.changedTouches[0].pageX;
      const delta = endX - startX;

      if (delta > 50) {
        gotoSlide(currentIndex - 1);
      } else if (delta < -50) {
        gotoSlide(currentIndex + 1);
      } else {
        updateSlider();
      }

      startAutoSlide();
    }

    track.addEventListener('mousedown', pointerDown);
    track.addEventListener('mousemove', pointerMove);
    track.addEventListener('mouseup', pointerUp);
    track.addEventListener('mouseleave', pointerUp);

    track.addEventListener('touchstart', pointerDown);
    track.addEventListener('touchmove', pointerMove);
    track.addEventListener('touchend', pointerUp);

    updateSlider();
    startAutoSlide();
  });
});
